export const formatNumber = (
  num: number,
  symbol: 'short' | 'long' = 'short',
  includeK: boolean = false,
) => {
  const lookup = [
    {
      value: 1e9,
      symbol: {
        short: 'B',
        long: ' billion',
      },
      digits: 0,
    },
    {
      value: 1e6,
      symbol: {
        short: 'M',
        long: ' million',
      },
      digits: 0,
    },
  ];
  if (includeK) {
    lookup.push({
      value: 1e3,
      symbol: {
        short: 'K',
        long: ' thousand',
      },
      digits: 0,
    });
  }
  lookup.push({
    value: 1,
    symbol: {
      short: '',
      long: '',
    },
    digits: 0,
  });
  const item = lookup.find(item => num >= item.value);
  if (!item) return 0;
  return `${(num / item.value).toLocaleString('en-US', {
    minimumFractionDigits: item.digits,
    maximumFractionDigits: item.digits,
  })}${item.symbol[symbol]}`;
};

export const calculatePercentage = (
  part: number,
  total: number,
  precision: number = 0,
): string => {
  if (total === 0) {
    return '0%';
  }
  const percentage = Math.min((part / total) * 100, 100);
  return percentage.toFixed(precision);
};
